export default "__VITE_ASSET__Quq4OT9k__"